var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDotIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 5,
    viewBox: "0 0 4 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2.5,
    r: 2,
    fill: "#4F6FFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotIcon);
export default __webpack_public_path__ + "static/media/dot-icon.b9d56f24a05e139bb67ce2a1a5a23b1f.svg";
export { ForwardRef as ReactComponent };